module.exports = __webpack_public_path__ + "static/media/logo1.8b070740.svg";